import {useEffect, useMemo} from 'react';
import {useReservation} from 'context/reservation';
import {
  useLivenessModelsStore,
  usePreloadLivenessModels,
  canUseClientSideDetection,
} from '@chekin/shared';
import ChekinProSettings from 'ChekinProSettings';

export const LivenessModelPreloader = () => {
  const {housing} = useReservation();
  const setIsWebGLSupported = useLivenessModelsStore(state => state.setIsWebGLSupported);
  const forceLivenessMechanism = housing?.force_liveness_mechanism || 'AUTO';

  const isDeviceCapable = useMemo(() => {
    if (ChekinProSettings.isSDK) {
      return false;
    }

    if (forceLivenessMechanism === 'SERVER') {
      return false;
    }

    if (forceLivenessMechanism === 'CLIENT') {
      return true;
    }

    return canUseClientSideDetection({
      setIsWebGLSupported,
    });
  }, [setIsWebGLSupported, forceLivenessMechanism]);

  const {preload} = usePreloadLivenessModels();

  useEffect(() => {
    if (!housing?.id || !isDeviceCapable || forceLivenessMechanism === 'SERVER') {
      return;
    }

    if (housing.is_liveness_detection_enabled) {
      void preload();
    }
  }, [
    preload,
    housing?.id,
    isDeviceCapable,
    forceLivenessMechanism,
    housing?.is_liveness_detection_enabled,
  ]);

  return null;
};
